import React from "react";
import {isTrue} from "../../../utils/general";

import './Dropdown.scss';

const Dropdown = props => {
	const {selectedValue, items, onChange, keyField, labelField, disabled, square, theme, topOption, width, isQueryLogic, multiple} = props;

	let style = {};

	switch(theme) {
		case "dark":
			style = {backgroundColor: '#062229', color: 'white'};
			break;
	}

	let key = 1;
	const options = [];

	if(topOption) {
		options.push(<option key={key++} value={topOption[keyField]}>{topOption[labelField]}</option>);
	}

	items.forEach(item => {
		if(typeof(item) === "object") {
			options.push(<option key={key++} disabled={item.disabled} value={item[keyField]}>{item[labelField]}</option>);
		}
		else {
			options.push(<option key={key++} value={item}>{item}</option>);
		}
	});

	return (
		<select disabled={isTrue(disabled)}
		        multiple={!!multiple}
		        style={Object.assign({}, style, {width: `${width}px` || '180px'})}
		        className={isQueryLogic ? 'reports-query-logic' : square ? 'dropdown-container-square' : 'dropdown-container'}
		        onChange={evt => {
			        if(multiple) {
			        	const selected = Array.from(evt.target.selectedOptions).map(o => o.value);
			        	onChange(selected);
			        } else {
			        	onChange(evt.target.value);
			        }
		        }} value={selectedValue || (multiple ? [] : '')}>
			{ options }
		</select>
	)
};

export default Dropdown;
